import React from 'react';

import { cn } from 'src/component/ds/utils';

/*
 * The placeholder banner behind the facility map, until facility image upload
 * exists.
 */

const WIDTH = 1057;
const HEIGHT = 369;
const GRID = 38;
const GRID_OFFSET = 0.5;

/* The six trace routes, as measured off the export. */
const TRACES = [
  'M 0 114 L 170 114 L 170 214 L 279 214 L 386 214',
  'M 282 214 L 282 266 L 0 266',
  'M 280 208 L 380 208 L 380 76 L 654 76 L 654 256 L 894 256 L 894 160 L 1057 160',
  'M 384 208 L 462 208 L 462 320 L 819 320 L 880 320',
  'M 300 0 L 300 76 L 450 76 L 450 206',
  'M 820 369 L 820 279 L 950 279 L 950 190 L 1057 190',
];

/* Junction nodes. Present in the light export only -- the dark one drops them,
 * so they are painted with a token that goes transparent under `.ds-dark`. */
const NODES: Array<[number, number]> = [
  [170, 114], [450, 206], [384, 208], [462, 208], [894, 256], [282, 266],
];

export interface TracePatternProps {
  className?: string;
}

export default function TracePattern ({ className }: TracePatternProps) {
  return (
    <svg
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      preserveAspectRatio='xMidYMin slice'
      aria-hidden='true'
      focusable='false'
      className={cn('ds-h-full ds-w-full', className)}
      data-testid='trace-pattern'
    >
      <defs>
        <linearGradient id='ds-trace-bg' x1='0' y1='0' x2='1' y2='1'>
          <stop offset='0' stopColor='var(--ds-trace-bg-from)' />
          <stop offset='1' stopColor='var(--ds-trace-bg-to)' />
        </linearGradient>

        <pattern
          id='ds-trace-grid'
          width={GRID}
          height={GRID}
          patternUnits='userSpaceOnUse'
          x={GRID_OFFSET}
          y={GRID_OFFSET}
        >
          <path
            d={`M ${GRID} 0 L 0 0 L 0 ${GRID}`}
            fill='none'
            stroke='var(--ds-trace-grid)'
            strokeWidth='1'
          />
        </pattern>
      </defs>

      <rect width={WIDTH} height={HEIGHT} fill='url(#ds-trace-bg)' />
      <rect width={WIDTH} height={HEIGHT} fill='url(#ds-trace-grid)' />

      <g
        fill='none'
        stroke='var(--ds-trace-line)'
        strokeWidth='2'
        strokeLinecap='square'
        strokeLinejoin='miter'
      >
        {TRACES.map((d) => <path key={d} d={d} />)}
      </g>

      {NODES.map(([cx, cy]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r='4' fill='var(--ds-trace-node)' />
      ))}
    </svg>
  );
}
